
import Vue from "vue";

export default Vue.extend({
  name: "hero-banner",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    img: { type: String, default: null },
    imgDesc: { type: String, default: null },
  },
});
